/**
 * index.js — Application entry point.
 *
 * Mounts the React app into the #root DOM node. Provider order matters:
 *   ThemeProvider  — must be outermost so Navbar/ThemeToggle can read the theme.
 *   AuthProvider   — wraps everything so any route can access auth state.
 *   App            — the root router and route tree.
 *
 * React.StrictMode is enabled to surface potential issues during development
 * (double-invokes effects, warns on deprecated APIs). It has no effect in
 * production builds.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
